<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="min-width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field class="file">
          <b-upload v-model="model.file" v-validate="'required'" @input="pushName" name="file">
            <a class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>Выберите файл</span>
            </a>
          </b-upload>
          <span class="file-name" v-if="model.file">
            {{ model.file.name }}
          </span>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" :disabled="disabled">Загрузить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>


<script>
  export default {
    name: "UploadForm",
    props: {
      title: String
    },
    data() {
      return {
        disabled: false,
        model: {
          file: null,
          file_name: undefined
        }
      }
    },
    methods: {
      pushName(file){
        let $this = this
        if(file){
          $this.model.file_name = file.name
        }
      },
      doUpload: function(e) {
        let $this = this
        let formData = new FormData();

        if ($this.model.file) {
          formData.append('file', $this.model.file)
          if ($this.model.file_name) {
            formData.append('name', $this.model.file_name)
          }
          $this.disabled = true
          $this.$store.dispatch('uploadFile', formData)
        }
      },
      validateBeforeSubmit() {
        let $this = this
        this.$validator.validateAll().then((result) => {
          if (result) {
            $this.doUpload()
            return;
          }
          this.$toast.open({
            message: $this.$i18n.t('notify.form_error'),
            type: 'is-danger',
            position: 'is-bottom'
          })
        });
      },
    }
  }
</script>